import './WidgetGlassOverlay.css';

import { cn } from '@/lib/utils';

type WidgetGlassOverlayProps = {
  className?: string;
};

export function WidgetGlassOverlay({ className }: WidgetGlassOverlayProps) {
  return (
    <div
      className={cn(
        'absolute inset-0 overflow-hidden rounded-[inherit]',
        'widget-glass-overlay',
        className
      )}
      aria-hidden='true'
    />
  );
}
